import Api_Usermanagement from '../api-usermanagement'
import Api_Masterdata from '../api-masterdata'
import Api_Masterdata_v2 from '../api-masterdata-v2'

const api = new Api_Usermanagement().init()
const api_masterdata = new Api_Masterdata().init()
const api_masterdata_v2 = new Api_Masterdata_v2().init()
const prefix = '/order-submission'

const getOrderAll = (cred, filter, cus) => {
  return api.get(
    prefix + `/all?credentials=${cred}&po_number_orderby=${filter}&customer_name_orderby=${cus}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const createOrder = (data) => {
  return api.post(prefix + `/create?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getOrderDetail = (id, cred, flag) => {
  return api.get(prefix + `/detail/${id}?credentials=${cred}${flag ? `&flag=${flag}` : ''}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createScheduleOrder = (id, data, amend = 'false') => {
  return api.post(prefix + `/schedule/create/${id}?is_amendment=${amend}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getScheduleOrder = (id, amend = 'false') => {
  return api.get(prefix + `/schedule/all/${id}?is_amendment=${amend}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const editSchedulle = (id, data) => {
  return api.put(prefix + `/schedule/update/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const deleteSchedule = (id) => {
  return api.delete(prefix + `/schedule/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const reject = (note) => {
  return api.put(
    prefix + `/revision-reject/90?credentials=${localStorage.getItem('credential')}`,
    note,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const revision = (note) => {
  return api.put(
    prefix + `/revision-reject/2?credentials=${localStorage.getItem('credential')}`,
    note,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const approve = (id, data) => {
  return api.put(
    prefix + `/approve/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAttachment = (id, credential) => {
  return api.get(`/attachment/all/header?attach_parent=${id}&credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getChild = (id) => {
  return api.get(prefix + `/child-detail/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const editChild = (id, lang, data) => {
  return api.put(
    prefix + `/child-edit/${id}/${lang}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateSales = (id, data) => {
  return api.put(
    prefix + `/negotiate/submit/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateSalesAll = (id, cred, data) => {
  return api.put(prefix + `/negotiate/submit-all/${id}?credentials=${cred}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const updateNegoAll = (cred, data) => {
  return api.put(prefix + `/negotiate/submit-each-all?credentials=${cred}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rejectSales = (id, cred, data) => {
  return api.put(prefix + `/negotiate/reject/${id}?credentials=${cred}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const negoAll = (id, cred) => {
  return api.put(prefix + `/negotiate/open-all/${id}?credentials=${cred}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const negoSatuan = (id, cred) => {
  return api.put(prefix + `/negotiate/open/${id}?credentials=${cred}`, undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const negoList = (credentials, negoId, customer, productNa, negoDate, isHistory = false, flag = '3') => {
  const filter = {
    credentials,
  }
  if (negoId) {
    filter['order_id'] = negoId
  }
  if (negoDate) {
    filter['date'] = negoDate
  }
  if (customer) {
    filter['customer_name'] = customer
  }
  if (productNa) {
    filter['product_name'] = productNa
  }
  if(isHistory){
    filter['flag'] = 1
  } else {
    filter['flag'] = flag
  }

  return api.get(prefix + `/negotiate/list?` + new URLSearchParams(filter).toString(), {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const editChildPlant = (id, data) => {
  return api.put(prefix + `/child-edit-plant/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPriceList = (code, sales, product, city, plant, incoterm, unit = '') => {
  return api_masterdata_v2.get(
    `/price?customer_code=${code}&sales_org_code=${sales}&product_code=${product}&city_code=${city}&plant_code=${plant}&incoterm_code=${incoterm}&unit=${unit}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getStockAvailability = (options) => {
  const query = new URLSearchParams(options).toString();
  return api.get(
    `/check-stock?` + query,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const postAttachment = (data) => {
  return api.post(`/attachment/create/order-submission`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getListBank = () => {
  return api.get(`/bank/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getListBankWithCurr = (currency = 'IDR') => {
  return api_masterdata.get(`/bank/list?flag=1&currency=` + currency, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAccesses = (id) => {
  return api.get(`/role-access/detail/${id}/137`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const searchOrder = (
  cred,
  po,
  status,
  sector,
  date,
  date2,
  regarding,
  kuantum,
  cust,
  sales,
  totalPrice,
  outstanding = 'false'
) => {
  return api.get(
    prefix +
      `/all?credentials=${cred}&po_number=${po}&status=${status}&sector_id=${sector}&from_date=${date}&to_date=${date2}&regarding=${regarding}&total_request_quantum=${kuantum}&customer_name=${cust}&sales_org_code=${sales}&total_request_price=${totalPrice}&outstanding_data=${outstanding}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const rejectNegoAll = (id, type, cred, note) => {
  return api.put(prefix + `/negotiate/reject/${type}/${id}?credentials=${cred}`, note, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rejectNego = (id, type, note) => {
  return api.put(
    prefix + `/negotiate/reject/${type}/${id}?credentials=${localStorage.getItem('credential')}`,
    note,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const exportChat = (lang, chat) => {
  return api.post(`/negotiation/store/${lang}`, chat, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const statusOrder = (cred) => {
  return api.get(`/notification/approvals?credentials=${cred}&role=customer_negotiation_closed`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const nonSalesList = () => {
  return api.get(`/order-submission/non-sales/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCommentOrder = (id, param = 'order') => {
  return api.get(`/comment/${id}/${param}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getChatOrder = (id, flag) => {
  return api.get(`/comment/${id}/${flag}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const postChatOrder = (lang, data, flag) => {
  return api.post(`/comment/send/${lang}/${flag}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const postCommentBulk = (lang, type, data) => {
  return api.post(`/findoc-comment/send-bulk/${lang}/${type}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const rollbackOrder = (id, lang) => {
  return api.put(
    `/order-submission/child-rollback/${id}?credentials=${localStorage.getItem(
      'credential'
    )}&lang=${lang}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const resubmitOrder = (id, lang, data) => {
  return api.put(`/order-submission/resubmit/${id}/${lang}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const approveOtorisator = (id, data) => {
  return api.put(
    `/order-submission/approve-otorisator/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

export {
  getListBank,
  getListBankWithCurr,
  getOrderAll,
  createOrder,
  getOrderDetail,
  createScheduleOrder,
  getScheduleOrder,
  reject,
  revision,
  approve,
  getAttachment,
  negoList,
  editChild,
  getChild,
  updateSales,
  updateSalesAll,
  updateNegoAll,
  rejectSales,
  negoAll,
  negoSatuan,
  editChildPlant,
  getPriceList,
  postAttachment,
  getAccesses,
  searchOrder,
  rejectNegoAll,
  rejectNego,
  exportChat,
  getChatOrder,
  postChatOrder,
  statusOrder,
  nonSalesList,
  editSchedulle,
  deleteSchedule,
  getCommentOrder,
  postCommentBulk,
  rollbackOrder,
  resubmitOrder,
  approveOtorisator,
  getStockAvailability
}
